var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useStorageLocationConfiguration } from "@/composables/storageLocation";
import { useObjectStoreStore } from "@/stores/objectStoreStore";
import ObjectStoreSelectButton from "./ObjectStoreSelectButton.vue";
import ObjectStoreSelectButtonDescribePopover from "./ObjectStoreSelectButtonDescribePopover.vue";
import ObjectStoreSelectButtonPopover from "./ObjectStoreSelectButtonPopover.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectObjectStore',
    props: {
        selectedObjectStoreId: { default: null },
        defaultOptionTitle: null,
        defaultOptionDescription: null,
        forWhat: null,
        parentError: { default: null }
    },
    emits: ["onSubmit"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useObjectStoreStore();
        const { isLoading, loadErrorMessage, selectableObjectStores } = storeToRefs(store);
        const { isOnlyPreference } = useStorageLocationConfiguration();
        const loadingObjectStoreInfoMessage = ref("Loading storage location information");
        const whyIsSelectionPreferredText = ref(`
Select a preferred storage location for new datasets. Depending on the job and workflow execution configuration of
this Galaxy a different storage location may be ultimately used. After a dataset is created,
click on the info icon in the history panel to view information about where it is stored. If it
is not stored in the place you want, contact Galaxy administrator for more information.
`);
        function variant(objectStoreId) {
            if (props.selectedObjectStoreId == objectStoreId) {
                return "outline-primary";
            }
            else {
                return "outline-info";
            }
        }
        const error = computed(() => {
            return props.parentError || loadErrorMessage.value;
        });
        function handleSubmit(preferredObjectStore) {
            return __awaiter(this, void 0, void 0, function* () {
                const id = (preferredObjectStore ? preferredObjectStore.object_store_id : null);
                const isPrivate = preferredObjectStore ? preferredObjectStore.private : false;
                emit("onSubmit", id, isPrivate);
            });
        }
        return { __sfc: true, props, store, isLoading, loadErrorMessage, selectableObjectStores, isOnlyPreference, loadingObjectStoreInfoMessage, whyIsSelectionPreferredText, variant, emit, error, handleSubmit, ObjectStoreSelectButton, ObjectStoreSelectButtonDescribePopover, ObjectStoreSelectButtonPopover, LoadingSpan };
    }
});
